module.exports = __webpack_public_path__ + "static/img/zwtp.b3a09a17.jpg";